/**
 * Help Tooltip Component
 * ======================
 * Shows helpful information on hover
 */

import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

interface HelpTooltipProps {
  content: string;
  className?: string;
}

export default function HelpTooltip({ content, className = '' }: HelpTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        className={`inline-flex items-center justify-center ${className}`}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onClick={(e) => {
          e.preventDefault();
          setIsVisible(!isVisible);
        }}
      >
        <HelpCircle className="w-4 h-4 text-gray-400 hover:text-gray-600 cursor-help" />
      </button>
      
      {isVisible && (
        <div className="fixed z-[9999] w-72 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-2xl pointer-events-none"
          style={{
            bottom: 'auto',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginTop: '8px'
          }}
        >
          <div className="relative">
            {content}
            {/* Arrow */}
            <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-[-1px]">
              <div className="border-4 border-transparent border-b-gray-900"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

